import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { getAnimalCarePage } from '~/lib/content/content'
import { CONTENT_ATTRIBUTE } from '~/lib/content/links'
import { Container } from '~/components/ui/Container'
import { RichText } from '~/components/ui/RichText'
import { ImageSlider } from '~/components/sections/ImageSlider'
import { DonateSignupBand } from '~/components/sections/DonateSignupBand'
import { PageTitle } from '~/components/ui/PageTitle'
import { PageHero } from '~/components/ui/PageHero'

// Copy and slides: content/animalcare.md (docs/content.md).
export const Route = createFileRoute('/animalcare')({
  loader: () => getAnimalCarePage(),
  headers: () => cacheHeaders.content,
  head: ({ loaderData }) =>
    pageMeta({
      title: 'DxE Animal Care',
      description: loaderData?.description,
    }),
  component: AnimalCare,
})

function AnimalCare() {
  const page = Route.useLoaderData()
  return (
    <>
      <PageHero bottom="section">
        <Container width="narrow">
          <PageTitle className="mb-6 text-center">{page.title}</PageTitle>
          <ImageSlider
            slides={page.slides}
            sizes="(min-width: 992px) 940px, 90vw"
            className="h-[200px] md:h-[325px] lg:h-[450px]"
          />
        </Container>
      </PageHero>

      <section className="pb-20">
        <Container width="narrow">
          {/* More room above headings than a blog post, as on the old page. */}
          <RichText
            html={page.html}
            className="[&_h2]:mt-12 [&_h2:first-child]:mt-0 [&_h3]:mt-10 [&_h4]:mt-6"
          />
          <div
            className="pt-[60px] text-center text-2xl leading-9 font-bold text-fg [&_a]:text-accent [&_a]:underline [&_a:hover]:text-accent-hover [&_p]:m-0 [&_p+p]:pt-5"
            {...CONTENT_ATTRIBUTE}
            dangerouslySetInnerHTML={{ __html: page.closingHtml }}
          />
        </Container>
      </section>

      <DonateSignupBand />
    </>
  )
}
